export default __webpack_public_path__ + "static/media/cta.888141b7.png";